import { JDSFileUploaderControlProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFileUploaderControlProps>
  ): React.FC<JDSFileUploaderControlProps> =>
  (props: JDSFileUploaderControlProps) => {
    return <Component {...props} />;
  };
